const rpcUrl = 'https://rpc.hyperliquid-testnet.xyz/evm',
    blockExplorers = 'https://testnet.purrsec.com'
export default {
    id: 998,
    name: 'HyperEVM Testnet',
    network: 'hyperEVM-testnet',
    nativeCurrency: {name: 'HYPE', symbol: 'HYPE', decimals: 18},
    rpcUrls: {
        default: {
            http: [rpcUrl],
        },
        public: {
            http: [rpcUrl],
        },
    },
    blockExplorers: {
        etherscan: {name: 'HyperEVMtestnet', url: blockExplorers},
        default: {name: 'HyperEVMtestnet', url: blockExplorers},
    },
    contracts: {},
}